<div class="container py-4" style="max-width: 720px">
    @if (missing) {
        <p>This action link is not valid.</p>
    }
    @if (report) {
        <h1 class="h3">{{ report.siteName }}</h1>
        <p>Sign off an action item after it is fixed.</p>
        <input class="form-control mb-2" placeholder="Your name" [(ngModel)]="name" />
        <input class="form-control mb-3" placeholder="Type your name to sign" [(ngModel)]="signature" />
        @for (item of report.actionItems; track item.id) {
            <div class="border rounded p-2 mb-2">
                <div>{{ item.status }} · {{ item.description }}</div>
                @if (item.status === 'Open') {
                    <button type="button" class="btn btn-primary btn-sm mt-2" [disabled]="!name || !signature" (click)="signOff(item.id)">Sign off</button>
                }
            </div>
        }
    }
</div>
